import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Form} from 'formik';
import FieldInput from '../../components/FieldInput';
import FieldDatepicker from '../../components/FieldDatepicker';
import FieldCheckbox from '../../components/FieldCheckbox';
import FieldSignature from '../../components/FieldSignature';
import Button from '../../components/Button';
import ErrorValidation from '../../components/ErrorValidation';
import styles from './styles.module.scss';

const Step6View = ({
                     agreements = [],
                     totalAgreementsCount,
                     deliveryValue,
                     isValid,
}) => {
  const allAgreementsAreOpen = agreements.length >= totalAgreementsCount;
  const buttonLabel = (allAgreementsAreOpen)
    ? (
      <FormattedMessage
        id='common.form.button.save'
        defaultMessage='Save'
      />
    )
    : (
      <FormattedMessage
        id='common.form.button.continueReading'
        defaultMessage='Continue reading'
      />
    );

  return (
    <Form className={styles.formContainer}>
      <div className={styles.form}>
        <div className={styles.titleBold}>
          <FormattedMessage
            id='step6.form.title'
          />
        </div>
        <FieldDatepicker
          fieldId='signDate'
          label={(
            <FormattedMessage
              id='step6.form.signDate.label'
              defaultMessage='This agreement was made and signed on'
            />
          )}
          containerStyles={`${styles.input} ${styles.inputWithCustomLabel}`}
          disabled={true}
          showIcon={false}
        />
        <div className={`${styles.text} ${styles.input}`}>
          <FormattedMessage
            id={'step6.form.between.label'}
            defaultMessage={'Between, on the one hand ( "Customer")'}
          />
        </div>
        <div className={`${styles.input} ${styles.spouse}`}>
          <FieldInput
            fieldId='firstName'
            label={(
              <FormattedMessage
                id='step6.form.firstName.label'
                defaultMessage='First Name'
              />
            )}
            disabled={true}
          />
          <FieldInput
            fieldId='lastName'
            label={(
              <FormattedMessage
                id='step6.form.lastName.label'
                defaultMessage='Last Name'
              />
            )}
            disabled={true}
          />
        </div>
        <FieldInput
          fieldId='idNumber'
          label={(
            <FormattedMessage
              id='step6.form.id.label'
              defaultMessage='Id'
            />
          )}
          containerStyles={styles.input}
          disabled={true}
        />
      </div>
      <div className={styles.contentBlock}>
        <FormattedMessage
          id={'step6.form.note.label'}
          defaultMessage={'And: <b>on the other hand</b>, Employee Self-employed Ltd. H.P. 513500181 (hereinafter: <b>"the Company"</b> and / or the <b>"Service Provider"</b>)'}
        />
      </div>
      <div className={`${styles.agreementsContainer} ${allAgreementsAreOpen && styles.contentBlock}`}>
        {
          agreements.map((item, index) => (
            <div key={index} className={styles.agreement}>
              <div className={styles.number}>{index + 1}</div>
              <div className={styles.content}>
                <FormattedMessage
                  id={item}
                  defaultMessage={item}
                  values={{
                    b: str => <span className={styles.bold}>{str}</span>,
                    deliveryValue
                  }}
                />
              </div>
            </div>
          ))
        }
      </div>
      {allAgreementsAreOpen && (
        <div className={styles.form}>
          <div className={styles.input}>
            <FormattedMessage
              id={'common.form.note.unigender'}
              defaultMessage={'The form is worded in masculine language but is addressed to both men and women'}
            />
          </div>
          <FieldSignature
            fieldId='signature'
            label={(
              <FormattedMessage
                id='common.form.signature.label'
                defaultMessage={'Customer\'s signature'}
              />
            )}
            containerStyles={styles.input}
            disabled={true}
          />
          <FieldCheckbox
            fieldId={'approveAdvertisement'}
            label={(
              <FormattedMessage
                id='step6.form.approveAdvertisement.label'
                defaultMessage='I want to receive advertisement at my email'
              />
            )}
            containerStyles={styles.input}
          />
          <FieldCheckbox
            fieldId={'approvePension'}
            label={(
              <FormattedMessage
                id='step6.form.approvePension.label'
                defaultMessage='I want to receive full pension advice at no cost!'
              />
            )}
            containerStyles={styles.input}
          />
          <FieldCheckbox
            fieldId={'approveInsurance'}
            label={(
              <FormattedMessage
                id='step6.form.approveInsurance.label'
                defaultMessage='I want to examine a discount on the mortgage, accident and health insurance!'
              />
            )}
            containerStyles={styles.input}
          />
          <FieldCheckbox
            fieldId={'approve'}
            label={(
              <FormattedMessage
                id='step6.form.approve.label'
                defaultMessage='I have read and I approve the terms of the agreement'
              />
            )}
            containerStyles={styles.input}
          />
        </div>
      )}
      <div className={styles.btnContainer}>
        <Button
          type='submit'
          label={buttonLabel}
        />
        {!isValid && <ErrorValidation />}
      </div>
    </Form>
  )
};

Step6View.propTypes = {
  agreements: PropTypes.array,
  totalAgreementsCount: PropTypes.number,
  deliveryValue: PropTypes.string,
  isValid: PropTypes.bool,
};

export default Step6View;
